/* Native swipe + lightweight progressive enhancement; no carousel library. */
if (!customElements.get('pfg-photo-cycle')) {
  customElements.define('pfg-photo-cycle', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.track = this.querySelector('.pfg-photo-track');
      if (!this.track || this.track.children.length < 2) return;
      this.slides = [...this.track.children];
      this.index = 0;
      this.inView = false;
      this.hovered = false;
      this.focused = false;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.pauseButton = this.querySelector('[data-pause]');
      this.status = document.createElement('span');
      this.status.className = 'visually-hidden';
      this.status.setAttribute('role', 'status');
      this.status.setAttribute('aria-atomic', 'true');
      this.append(this.status);
      this.querySelector('[data-prev]').addEventListener('click', () => this.move(-1, true), {signal});
      this.querySelector('[data-next]').addEventListener('click', () => this.move(1, true), {signal});
      this.pauseButton.addEventListener('click', () => {this.paused = !this.paused; this.updatePause(); this.schedule();}, {signal});
      this.addEventListener('mouseenter', () => {this.hovered = true; this.schedule();}, {signal});
      this.addEventListener('mouseleave', () => {this.hovered = false; this.schedule();}, {signal});
      this.addEventListener('focusin', () => {this.focused = true; this.schedule();}, {signal});
      this.addEventListener('focusout', e => {this.focused = this.contains(e.relatedTarget); this.schedule();}, {signal});
      this.track.addEventListener('pointerdown', () => {this.paused = true; this.updatePause(); this.schedule();}, {signal, passive:true});
      this.track.addEventListener('scroll', () => {clearTimeout(this.scrollTimer); this.scrollTimer = setTimeout(() => this.updateIndex(), 80);}, {signal, passive:true});
      this.addEventListener('keydown', e => {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {e.preventDefault(); this.move(e.key === 'ArrowRight' ? 1 : -1, true);}
      }, {signal});
      document.addEventListener('visibilitychange', () => this.schedule(), {signal});
      this.motion.addEventListener('change', () => {this.paused = this.motion.matches; this.updatePause(); this.schedule();}, {signal});
      this.observer = new IntersectionObserver(entries => {this.inView = entries[0].isIntersecting; this.schedule();}, {threshold:.25});
      this.observer.observe(this);
      this.setAttribute('data-pfg-ready', '');
      this.updateIndex(); this.updatePause();
    }
    updatePause() {
      this.pauseButton.textContent = this.paused ? '▷' : 'Ⅱ';
      this.pauseButton.setAttribute('aria-label', this.paused ? 'Play slideshow' : 'Pause slideshow');
      this.pauseButton.setAttribute('aria-pressed', String(this.paused));
    }
    updateIndex() {
      const x = this.track.scrollLeft;
      const base = this.slides[0].offsetLeft;
      this.index = this.slides.reduce((best, slide, i) => Math.abs(slide.offsetLeft - base - x) < Math.abs(this.slides[best].offsetLeft - base - x) ? i : best, 0);
      const pad = n => String(n).padStart(2, '0');
      this.querySelector('.pfg-cycle-counter').textContent = `${pad(this.index + 1)} / ${pad(this.slides.length)}`;
    }
    move(direction, manual = false) {
      this.updateIndex();
      const end = this.track.scrollWidth - this.track.clientWidth;
      const atEnd = this.track.scrollLeft >= end - 4;
      let next = this.index + direction;
      if (direction > 0 && atEnd) next = 0;
      if (direction < 0 && this.track.scrollLeft <= 4) next = this.slides.length - 1;
      next = (next + this.slides.length) % this.slides.length;
      this.track.scrollTo({left:this.slides[next].offsetLeft - this.slides[0].offsetLeft, behavior:this.motion.matches ? 'instant' : 'smooth'});
      if (manual) this.status.textContent = `Design ${next + 1} of ${this.slides.length}: ${this.slides[next].getAttribute('aria-label') || this.slides[next].querySelector('h3')?.textContent || ''}`;
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.paused || this.hovered || this.focused || !this.inView || document.hidden) return;
      this.timer = setTimeout(() => this.move(1), Number(this.dataset.interval) || 6500);
    }
    disconnectedCallback() {
      this.controller?.abort(); this.observer?.disconnect();
      clearTimeout(this.timer); clearTimeout(this.scrollTimer); this.controller = null;
    }
  });
}
document.addEventListener('click', e => {
  document.querySelectorAll('[data-pfg-menu][open]').forEach(menu => {
    if (!menu.contains(e.target) || e.target.closest('[data-menu-close]')) {
      menu.removeAttribute('open');
      if (e.target.closest('[data-menu-close]')) menu.querySelector('summary')?.focus();
    }
  });
});
document.addEventListener('keydown', e => {
  if (e.key === 'Escape') document.querySelectorAll('[data-pfg-menu][open]').forEach(menu => {menu.removeAttribute('open'); menu.querySelector('summary')?.focus();});
});
